<script>
    import BagPriceWidget from "./BagPriceWidget.vue";
    import BagPriceInfo from "./BagPriceInfo.vue";
    import BagPriceFlightSelect from "./BagPriceFlightSelect.vue";
    import { postJson } from "shared/Utilities/fetchUtilities";
    import moment from "moment";
    
    //TODO REMOVE MOCK DATA!!
    const mockOrigin = "XXX", mockDestination = "YYY",
        mockFlightData = {
            departureTimes: [{
                    displayTime: "12:45am",
                    key: "asdlfjsadjkl"
                },
                {
                    displayTime: "8:30am",
                    key: "fdgsdfgsdfg"
                }],
            returnTimes:[{
                    displayTime: "4:45pm",
                    key: "sdfasdfasdfasdf"
                },
                {
                    displayTime: "5:30pm",
                    key: "fsdafasdfasdf"
                }],
            overrideKey: 1234567
        },
        mockPriceData = {
            flightUnavailable: false,
            priceData:[
                {
                    title: "Carry On<span class='hide-sm hide-md'>&nbsp;Bag</span>",
                    subTitle: "",
                    ibCost: "$XX",
                    ibStrike: "$XX",
                    mmbCost: "$XX",
                    mmbStrike: "$XX",
                    checkinCost: "$XX",
                    kioskCost: "$XX",
                    gateCost: "$XX",
                    rezCost: "$XX"
                },
                {
                    title: "1st Checked<span class='hide-sm hide-md'>&nbsp;Bag</span>",
                    subTitle: "",
                    ibCost: "$XX",
                    ibStrike: "$XX",
                    mmbCost: "$XX",
                    mmbStrike: "$XX",
                    checkinCost: "$XX",
                    kioskCost: "$XX",
                    gateCost: "$XX",
                    rezCost: "$XX"
                },
                {
                    title: "2nd Checked<span class='hide-sm hide-md'>&nbsp;Bag</span>",
                    subTitle: "",
                    ibCost: "$XX",
                    ibStrike: "$XX",
                    mmbCost: "$XX",
                    mmbStrike: "$XX",
                    checkinCost: "$XX",
                    kioskCost: "$XX",
                    gateCost: "$XX",
                    rezCost: "$XX"
                },
                {
                    title: "3 + Checked<span class='hide-sm hide-md'>&nbsp;Bag</span>",
                    subTitle: "price per<span class='hide-sm hide-md'>&nbsp;Bag</span>",
                    ibCost: "$XX",
                    ibStrike: "$XX",
                    mmbCost: "$XX",
                    mmbStrike: "$XX",
                    checkinCost: "$XX",
                    kioskCost: "$XX",
                    gateCost: "$XX",
                    rezCost: "$XX"
                },
            ]
        },
        mockDataWaitTime = 2000;

    export default {
        data() {
            return {
                paramsChanged: false,
                searchParams: {},
                flightData: null,//array of journeys -- apply mock data here if you want flight select dropdowns to show on initial load
                priceData: null,//array of bag prices -- apply mock data here if you want bag prices grid to show on initial load
                origin: null,
                destination: null,
                overrideKey: 0,
                searching: false,
                isExisting: false,
                bookingNotFound: false
            };
        },
        computed: {
            hideFlightSelect() {
                if(this.flightData || this.priceData) {
                    return this.paramsChanged;
                }
                return true;
            },
            roundTrip() {
                return this.searchParams.returnDate ? true : false;
            }
        },
        methods: {
            showSelect() {
                this.$refs.select.$el.scrollIntoView({ behavior: "smooth" });
            },
            search(search) {
                this.searching = true;
                if(search.existing) {
                    this.isExisting = true;
                    this.bookingNotFound = false;
                    this.flightData = this.priceData = null;
                    
                    postJson("/Umbraco/api/apo/GetExistingBagPrices", search.params)
                        .then(result => {
                            this.paramsChanged = false;
                            this.priceData = result;
                            if(!this.priceData || !this.priceData.priceData || !this.priceData.priceData.length) {
                                this.$root.$emit('bookingNotFound', this.bookingNotFound = true);
                            }
                        }).catch(error => {
                            this.paramsChanged = false;
                            this.$root.$emit('bookingNotFound', this.bookingNotFound = true);
                        })
                        .then(() => this.searching = false);
                } else {
                    const params = JSON.parse(JSON.stringify(search.params));
                    params.departDate = moment(search.params.departDate).format("YYYY-MM-DD");
                    if(params.returnDate) {
                        params.returnDate = moment(search.params.returnDate).format("YYYY-MM-DD");
                    }

                    this.searchParams = params;
                    this.origin = search.params.origin;
                    this.destination = search.params.destination;
                    this.isExisting = false;
                    this.flightData = this.priceData = null;
                    
                    postJson("/Umbraco/api/apo/RetrieveFlightTimes", params)
                        .then(result => {
                            this.paramsChanged = false;
                            this.flightData = result;
                        }).catch(error => {
                            this.searching = false;
                            console.log("new search error", error);
                        })
                        .then(() => this.searching = false);
                }
            },
            select(params) {
                this.searching = true;
                this.priceData = null;
                
                postJson("/Umbraco/api/apo/GetNewBagPrices", {
                    requestData: this.searchParams,
                    departKey: params.departureFlight,
                    returnKey: params.returnFlight
                }).then(result => {
                    this.paramsChanged = this.searching = false;
                    if(result.errorMessage) {
                        this.priceData = { flightUnavailable: true, errorMessage: result.errorMessage };
                    }
                    else{
                        this.priceData = result;
                        if(!this.priceData.priceData || !this.priceData.priceData.length) {
                            this.priceData.flightUnavailable = true;
                        }
                    }
                }).catch(error => {
                    this.paramsChanged = this.searching = false;
                    this.priceData = { flightUnavailable: true };
                });
            },
            tabChanged() {
                this.flightData = this.priceData = null;
            }
        },
        watch: {
            paramsChanged(val) {
                if(val) {
                    this.flightData = this.priceData = null;
                }
            }
        },
        components: {
            BagPriceWidget,
            BagPriceInfo,
            BagPriceFlightSelect
        }
    }
</script>

<template>
    <div class="bag-price-container vertical center top">
        <div class="horizontal top center" @change="paramsChanged = true">
            <bag-price-widget :searching="searching" @tabChanged="tabChanged" @search="search"></bag-price-widget>
            <bag-price-info class="hide-md-lg hide-md hide-sm"></bag-price-info>
        </div>
        <bag-price-flight-select ref="select" :origin="origin" :destination="destination" class="flight-select" 
            :class="{ noheight: hideFlightSelect }" :done-searching="!searching" :is-existing="isExisting"
            :flight-data="flightData" :price-data="priceData" :roundTrip="roundTrip" @select="select"></bag-price-flight-select>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .bag-price-container {
        .flight-select {
            height: auto;
            overflow: hidden;
            max-height: 1000vh;
            transition: max-height 2s;

            &.noheight {
                max-height: 0;
                padding: 0;
            }
        }

        @{deep} {
            input, select {
                &::placeholder {
                    color: @frontier-gray-xxdark;
                    opacity: 1;
                }

                color: @frontier-gray-xxdark;
            }
        }
    }

    @media @tablet-lg {
        .bag-price-container {
            width: 100vw;
            margin: 0 auto;
            margin-top: 14px;

            &>.horizontal {
                justify-content: center;
            }
        }
    }
</style>